import React from 'react';
import './BrandPartnerships.css';

const BrandPartnerships = () => {
  const brandData = [
    { name: 'Michael Kors', posts: 53, creators: 3, engagement: 2.8 },
    { name: 'SiriusXM', posts: 26, creators: 10, engagement: 1.4 },
    { name: 'Prime Video', posts: 25, creators: 12, engagement: 1.9 },
    { name: 'Adidas', posts: 24, creators: 13, engagement: 2.1 },
    { name: 'Lionsgate', posts: 18, creators: 11, engagement: 1.2 },
    { name: 'Dior', posts: 18, creators: 9, engagement: 3.2 },
    { name: 'Chanel', posts: 16, creators: 10, engagement: 2.9 },
    { name: 'Hulu', posts: 15, creators: 10, engagement: 1.1 },
    { name: 'Prada', posts: 15, creators: 9, engagement: 2.7 },
    { name: 'Netflix', posts: 15, creators: 10, engagement: 1.5 }
  ];

  return (
    <div className="brand-partnerships glass-card">
      <h3 className="section-title">Top Brand Partnership Performance</h3>
      
      <div className="brands-table">
        <div className="table-header">
          <div className="header-cell">Brand</div>
          <div className="header-cell">Posts</div>
          <div className="header-cell">Creators</div>
          <div className="header-cell">Eng Rate</div>
        </div>
        
        {brandData.map((brand, index) => (
          <div key={brand.name} className="table-row">
            <div className="brand-cell">
              <span className="brand-rank">{index + 1}</span>
              <span className="brand-name">{brand.name}</span>
            </div>
            <div className="data-cell">
              <span className="cell-value">{brand.posts}</span>
            </div>
            <div className="data-cell">
              <span className="cell-value">{brand.creators}</span>
            </div>
            <div className="data-cell">
              <span className={`engagement-rate ${brand.engagement > 2 ? 'high' : ''}`}>
                {brand.engagement}%
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="partnership-summary">
        <div className="summary-item">
          <span className="summary-icon">🏆</span>
          <span className="summary-text">Michael Kors leads with 53 posts</span>
        </div>
        <div className="summary-item">
          <span className="summary-icon">👥</span>
          <span className="summary-text">Prime Video maximizes creator diversity</span>
        </div>
        <div className="summary-item">
          <span className="summary-icon">💎</span>
          <span className="summary-text">Luxury brands show highest engagement</span>
        </div>
      </div>
    </div>
  );
};

export default BrandPartnerships;